import { useUserEditorContext } from "../context/UserEditorContext";
import { ContactGrid } from "@/modern/components/grids/contactGrid/ContactGrid";

export const ContactTab = () => {
  const { userRecord } = useUserEditorContext();
  return <ContactGrid userRecord={userRecord} />;
};
